import { render, staticRenderFns } from "./liveBookingForm.vue?vue&type=template&id=2243215a&scoped=true"
import script from "./liveBookingForm.vue?vue&type=script&lang=js"
export * from "./liveBookingForm.vue?vue&type=script&lang=js"
import style0 from "./liveBookingForm.vue?vue&type=style&index=0&id=2243215a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2243215a",
  null
  
)

export default component.exports